import styled from 'styled-components';

export const PosterWrapper = styled.div`
  margin: 0 auto;
  height: 100%;
  width: 100%;
`;

export const Clips = styled.div`
  display: flex;
  justify-content: center;
  height: 10%;
  width: 100%;
`;

export const Clip = styled.div`
  z-index: 1;
  text-align: right;
  width: 50%;

  & + div {
    text-align: left;
  }

  img {
    height: 120%;
    padding: 0 calc(0.16 * 100vh);
  }
`;
export const PosterContent = styled.div`
  height: 85%;
  text-align: center;
`;

export const PosterImage = styled.div`
  background-color: #fff;
  box-shadow: 2px 2px 30px 0px #bbb;
  display: inline-block;
  /* should be 100% but causes bug in firefox, therefore needs to be calculated without % values */
  height: calc(85vh - 50px);
  position: relative;
  margin: 0 0.2rem;

  img {
    height: 100%;
  }

  .hidden {
    display: none;
  }
`;

export const Shadow = styled.div`
  background: linear-gradient(
    165deg,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.06)
  );
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;
